<template>
  <div class="empty-block" @mouseover="showAddButton = true" 
  @mouseleave="showAddButton = false">
    <span class="add-icon" @click.stop="toggleAddList($event); 
    ">+</span>
    <AddList 
      v-if="showAddList" 
      :style="addListStyle" 
      @close="closeAddList" 
      @closeAdd="closeAddList" 
      ref="addList" 
      @addBlockE="addBlockEmpty" 
      :clicked="clicked" 
      :position="position" 
      :parentEmpty = "parentType"
      :parentType = "parentType" 
      :index = index
      :blockId= parentId
    />
  </div>
</template>

<script>
import AddList from '../Reusables/AddList.vue';
import { mapActions } from 'vuex';

export default {
  name: 'EmptyBlock',
  components: {
    AddList,
  },
  props: {
    parentId: { //Id of the parent component
      type: String,
      required: true
    },
    parentType: { //defines parent as root/container/columnscontainer
      type: String,
      required: true
    },
    index: { //only important for columnsContainer
      type: Number,
      default: null
    }},
  data() {
    return {
      showAddButton: false,
      showAddList: false,
      addListStyle: {},
      clicked: "empty", //type of the component
      position: 'bottom' // Just a dummy value as new Block is a replacement
    };
  },
  methods: {
    ...mapActions(['addNewBlock']),
    toggleAddList(event) {
      event.stopPropagation();
      const buttonRect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentElement.getBoundingClientRect();
      const top = buttonRect.bottom - parentRect.top;
      const left = buttonRect.left - parentRect.left;

      this.addListStyle = {
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translateY(20px)', // adjust as needed
        position: 'absolute',
        zIndex: 10,
      };
      this.showAddList = !this.showAddList;

      if (this.showAddList) {
        document.addEventListener('click', this.handleClickOutside);
      } else {
        document.removeEventListener('click', this.handleClickOutside);
      }
    },
    handleClickOutside(event) {
      const addListElement = this.$refs.addList?.$el;
      if (addListElement && !addListElement.contains(event.target)) {
        this.closeAddList();
      }
    },
    closeAddList() {
      this.showAddList = false;
      document.removeEventListener('click', this.handleClickOutside);
    },
   /*  addBlockEmpty(type) {
      let parentId;
      let parentType;
      console.log(type)
      // Determine if this EmptyBlock is inside root or another container
      if (this.$parent.$options.name === 'Preview') {
        parentId = 'root';
        parentType = 'root';
      } else {
        parentId = this.$parent.data.props.childrenIds ? this.$parent.data : 'root';
        parentType = this.$parent.data.props.childrenIds ? this.$parent.data.type : 'root';
      }

      this.addNewBlock({ type, position: 'bottom', parentId, parentType, targetId: parentId === 'root' ? null : this.$parent.$attrs['data-id'] });
      console.log({ type, position: 'bottom', parentId, parentType, targetId: parentId === 'root' ? null : this.$parent.$attrs['data-id'] })
      this.closeAddList();
    } */
    addBlockEmpty(type) {
    this.addNewBlock({
      type,
      position: 'bottom',
      parentId: this.parentId,
      parentType: this.parentType,
      //targetId: this.$parent.$el.getAttribute('data-id'), // Get the targetId
      targetId: null,
      placeholderIndex: this.index
    });
    this.closeAddList();
  }
},
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.empty-block {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  height: 60px;
  position: relative;
  cursor: pointer;
  border: 2px dashed #ccc;
  transition: background-color 0.3s;
}

.empty-block:hover {
  background-color: #e0e0e0;
}

.add-icon {
  font-size: 22px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.add-list {
  position: absolute;
  z-index: 10;
}
</style>
